export default "__VITE_ASSET__CH714pNF__"